import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from "components/CustomButtons/Button.jsx";

class CompanyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: this.props.datatable
    };
  }

  getUserLevel = levelName => {
    let userlevelname;
    switch (levelName) {
      case 2:
        userlevelname = "Super Admin";
        break;
      case 0:
        userlevelname = "Programmer";
        break;
      case 3:
        userlevelname = "Guest";
        break;
      case 4:
        userlevelname = "Programmer";
        break;
      default:
        userlevelname = "Guest";
        break;
    }

    return userlevelname;
  };

  render() {
    const columns = [
      {
        name: "id",
        label: "ID",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "email",
        label: "Email",
        options: {
          filter: true
        }
      },
      {
        name: "name",
        label: "Name",
        options: {
          filter: true
        }
      },
      {
        name: "brithday",
        label: "Brithday",
        options: {
          filter: true
        }
      },
      {
        name: "gender",
        label: "Gender",
        options: {
          filter: true
        }
      },
      {
        name: "login_type",
        label: "Login Type",
        options: {
          filter: true
        }
      },
      {
        name: "picture_background_url",
        label: "Picture Background Url",
        options: {
          filter: true,
          display: false
        }
      },
      {
        name: "picture_url",
        label: "Picture Url",
        options: {
          filter: true,
          display: false
        }
      },

      {
        label: "Social Id",
        name: "social_id",
        options: {
          filter: true,
          display: false
        }
      },
      {
        label: "Description",
        name: "description",
        options: {
          filter: true,
          display: false
        }
      },

      {
        label: "Job",
        name: "job",
        options: {
          filter: true,
          display: false
        }
      },
      {
        label: "Company Code",
        name: "company_code",
        options: {
          filter: true
        }
      },
      {
        label: "User Level",
        name: "userlevel",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return this.getUserLevel(value);
          }
        }
      },
      {
        label: "OTP",
        name: "otp",
        options: {
          filter: true,
          display: false
        }
      },

      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let id = tableMeta.rowData !== undefined ? tableMeta.rowData[0] : 0;
            if (localStorage.getItem("userlevel") != 3) {
              return (
                <div>
                  <Button
                    color="danger"
                    round
                    onClick={() => this.props.handleDelete(id)}
                  >
                    Delete
                  </Button>
                  <Button
                    color="behance"
                    round
                    onClick={() => this.props.restate(tableMeta.rowData)}
                  >
                    Update
                  </Button>
                </div>
              );
            } else {
              return <div />;
            }
          }
        }
      }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.props.loader
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };

    return (
      <MUIDataTable
        title={"Users"}
        data={this.props.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

export default CompanyList;
